import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const useIsBelowBreakpoint = (breakpoint = 'sm') => {
  const { breakpoints } = useTheme()

  return useMediaQuery(breakpoints.down(breakpoint))
}

export default useIsBelowBreakpoint
